import React from 'react';
import { Play, ArrowRight } from 'lucide-react';

const HeroSection = () => {
  // Video URLs
  const desktopVideoUrl = "https://customer-assets.emergentagent.com/job_48f1fe7d-2f7d-4a42-86b1-7c0cd9a5bea8/artifacts/8e8aea1c_Infinitum_Portfolio_Global_Digital_Network_Influencers_Production_Studio_Learning_Network_1080P.mp4";
  const mobileVideoUrl = "https://customer-assets.emergentagent.com/job_medianet-showcase/artifacts/yq2ettob_Main%20Infinitum%20porfolio%20Verticle.mp4.mp4";

  return (
    <section className="w-full bg-black">
      {/* Video Section - Full Width */}
      {/* Desktop Video (16:9) - Hidden on mobile */}
      <div className="hidden md:block relative w-full" style={{ aspectRatio: '16/9' }}>
        <video
          autoPlay
          muted
          loop
          playsInline
          className="absolute inset-0 w-full h-full object-contain bg-black"
        >
          <source src={desktopVideoUrl} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
      
      {/* Mobile Video (9:16) - Hidden on desktop - Full width cover */}
      <div className="block md:hidden relative w-full bg-black" style={{ height: '75vh' }}>
        <video
          autoPlay
          muted
          loop
          playsInline
          className="absolute inset-0 w-full h-full object-cover"
        >
          <source src={mobileVideoUrl} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>

      {/* Content Section - Below Video */}
      <div className="bg-gray-900" style={{ paddingTop: '24px', paddingBottom: '32px', marginBottom: '0px' }}>
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            {/* Company Name & Tagline */}
            <h1 className="text-3xl md:text-6xl font-bold text-white mb-3 md:mb-4 animate-fade-in">
              INFINITUM
              <span className="block text-xl md:text-4xl font-normal text-[#00c6d7] mt-1 md:mt-2">
                NETWORK SOLUTIONS
              </span>
            </h1>
            
            {/* Description */}
            <p className="text-base md:text-xl text-gray-300 mb-6 md:mb-8 leading-relaxed animate-fade-in-delay max-w-3xl mx-auto px-2">
              A global technology and creative organization operating across multiple regions.
            </p>
            
            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center mb-8 md:mb-12 animate-fade-in-delay-2 px-4">
              <a
                href="#contact"
                className="inline-flex items-center justify-center px-6 md:px-8 py-3 md:py-4 bg-[#0077cc] text-white text-base md:text-lg font-medium rounded-full hover:bg-[#005fa3] transition-all hover:scale-105 shadow-lg"
                data-testid="hero-cta-btn"
              >
                Start Your Journey
                <ArrowRight className="ml-2" size={18} />
              </a>
              <a
                href="#webseries"
                className="inline-flex items-center justify-center px-6 md:px-8 py-3 md:py-4 bg-white/10 backdrop-blur-md text-white text-base md:text-lg font-medium rounded-full hover:bg-white/20 transition-all border-2 border-white/30"
                data-testid="hero-watch-btn"
              >
                <Play className="mr-2" size={18} />
                Watch Our Work
              </a>
            </div>

            {/* Stats Grid */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8 animate-fade-in-delay-3">
              <div className="text-center p-2 md:p-4">
                <div className="text-xl md:text-3xl font-bold text-[#00c6d7]">550+</div>
                <div className="text-xs text-gray-400 mt-1">YouTube Channels</div>
              </div>
              <div className="text-center p-2 md:p-4">
                <div className="text-xl md:text-3xl font-bold text-[#00c6d7]">200M+</div>
                <div className="text-xs text-gray-400 mt-1">Subscribers</div>
              </div>
              <div className="text-center p-2 md:p-4">
                <div className="text-xl md:text-3xl font-bold text-[#00c6d7]">200B+</div>
                <div className="text-xs text-gray-400 mt-1">Views</div>
              </div>
              <div className="text-center p-2 md:p-4">
                <div className="text-xl md:text-3xl font-bold text-[#00c6d7]">300+</div>
                <div className="text-xs text-gray-400 mt-1">Brand Projects</div>
              </div>
            </div>
            
            {/* Additional Stats Row */}
            <div className="grid grid-cols-3 gap-4 md:gap-6 mt-4 md:mt-6 animate-fade-in-delay-3">
              <div className="text-center p-2 md:p-4">
                <div className="text-xl md:text-3xl font-bold text-white">160+</div>
                <div className="text-xs text-gray-400 mt-1">Countries</div>
              </div>
              <div className="text-center p-2 md:p-4">
                <div className="text-xl md:text-3xl font-bold text-white">100+</div>
                <div className="text-xs text-gray-400 mt-1">Languages</div>
              </div>
              <div className="text-center p-2 md:p-4">
                <div className="text-xl md:text-3xl font-bold text-white">400+</div>
                <div className="text-xs text-gray-400 mt-1">IPs Developed</div>
              </div>
            </div>

            {/* Badge */}
            <div className="mt-4 md:mt-8 inline-block px-4 md:px-6 py-2 md:py-3 bg-gradient-to-r from-[#0077cc]/20 to-[#00c6d7]/20 border border-[#00c6d7]/30 rounded-full">
              <span className="text-[#00c6d7] font-medium text-xs md:text-base">
                Leading Enterprise MCN on YouTube
              </span>
            </div>
          </div>
        </div>
      </div>
      {/* Seamless transition element - prevents any gap */}
      <div style={{ height: '0px', margin: '0px', padding: '0px', lineHeight: '0', fontSize: '0', backgroundColor: '#1f2937' }}></div>
    </section>
  );
};

export default HeroSection;
